// import { gsap } from 'gsap'

// import { ScrollTrigger } from 'gsap/ScrollTrigger'

// gsap.registerPlugin(ScrollTrigger)

const initStackingCards = () => {
    setHeights()
}

const setHeights = () => {
    const parents = document.querySelectorAll('.blockStackingCards')

    parents.forEach((p) => {
        const cards = p.querySelectorAll('[data-stacking-card]')

        let height = 0
        cards.forEach((c) => {
            console.log(c)
            const cardHeight = c.offsetHeight
            console.log(cardHeight)
            if (cardHeight > height) {
                height = cardHeight
            }
        })
        if (window.innerWidth > 1024) {
            cards.forEach((c) => {
                c.style.height = `${height}px`
            })
        } else {
            cards.forEach((c) => {
                c.style.height = `auto`
            })
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initStackingCards()
})

window.addEventListener('resize', () => {
    setHeights()
})
